import { useEffect } from 'react';
import { POPUP_TYPES } from '@/features/Popup/constants';
import { GAME_WINDOW_TO_CLIENT_EVENTS } from '@/event-manager/types';
import useEventManagerEmitter from '@/event-manager/use-event-manager-emiter';
import { useStore } from '@/store/useStore';

const EXIT_POPUP_TYPES = new Set<string>([
  POPUP_TYPES.EXIT,
  POPUP_TYPES.EXIT_RECENTLY,
]);

/**
 * Stops game autoplay while a blocking popup is queued (exit popups excluded).
 * Reality Check is queue-only — its sentinel entry still counts here.
 */
export const usePopupAutoplayGuard = () => {
  const queue = useStore((s) => s.state);
  const { emitClientEvent } = useEventManagerEmitter();

  useEffect(() => {
    const hasBlockingPopups = (queue ?? []).some(
      (item) => item?.type && !EXIT_POPUP_TYPES.has(item.type),
    );

    if (hasBlockingPopups) {
      emitClientEvent(GAME_WINDOW_TO_CLIENT_EVENTS.AUTO_SPIN_STOP);
    } else {
      emitClientEvent(GAME_WINDOW_TO_CLIENT_EVENTS.AUTO_SPIN_RESUME);
    }
  }, [queue, emitClientEvent]);
};
